import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Set up Firebase
const firebaseConfig = {
  apiKey: "AIzaSyB9MSU1gqjiZ_3CjQcphbtpiPZ33sIOgng",
  authDomain: "zexdotwallet-8179b.firebaseapp.com",
  projectId: "zexdotwallet-8179b",
  storageBucket: "zexdotwallet-8179b.firebasestorage.app",
  messagingSenderId: "155258175375",
  appId: "1:155258175375:web:06f7e6e776b07ce4ead5fa"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state

export {
  app,
  auth,
  db,
  storage,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
};
